import { recordPath, recordRoute } from '@/shared/registry'

/** Where Find User Roles lives. */
export const findRolesPath = '/access-control/roles'

/** Where Create User Role, User Role Details and Edit User Role live. */
export const createRolePath = `${findRolesPath}/new`
export const roleRoute = recordRoute('access-control', 'roles')
export const editRoleRoute = `${roleRoute}/edit`

/** A role's details page. */
export function roleDetailsPath(id: string): string {
  return recordPath('access-control', 'roles', id)
}

/** A role's Edit User Role page. */
export function editRolePath(id: string): string {
  return `${roleDetailsPath(id)}/edit`
}

/** The base of User Role Details' slots (`detailsSlots`), such as a link another area adds to its menu. */
export const roleDetailsSlot = 'access-control.role-details'

/** What creating and changing roles needs; deleting one needs `access-control.roles.delete`. */
export const writeRolesPermission = 'access-control.roles.write'
export const deleteRolesPermission = 'access-control.roles.delete'
export const readRolesPermission = 'access-control.roles.read'
